import React from 'react'
import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Button } from '../Button'

export interface EmptyStateProps {
  title: string
  description?: string
  actionLabel?: string
  onAction?: () => void
  icon?: React.ReactNode
}

const Wrap = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: 'var(--ds-space-8) var(--ds-space-5)',
  gap: 'var(--ds-space-3)',
})

export function EmptyState({ title, description, actionLabel, onAction, icon }: EmptyStateProps) {
  return (
    <Wrap>
      {icon}
      <Typography sx={{ fontSize: 22, fontWeight: 700, color: 'var(--ds-ink)', m: 0 }}>
        {title}
      </Typography>
      {description && (
        <Typography sx={{ fontSize: 15, color: 'var(--ds-ink-muted)', maxWidth: 360, m: 0 }}>
          {description}
        </Typography>
      )}
      {actionLabel && onAction && (
        <Box mt={1}>
          <Button variant='primary' onClick={onAction}>
            {actionLabel}
          </Button>
        </Box>
      )}
    </Wrap>
  )
}
